"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Banner = void 0;

var noun_user = void 0;
var url_to_array = void 0;

noun_user = require("../helpers/noun_user").default;

url_to_array = require("../helpers/url_to_array").default;

Banner = function () {
    function Banner() {
        var $banners = void 0;
        $banners = (0, _jquery2.default)(".banner");
        if (noun_user.is_anonymous === false) {
            (0, _jquery2.default)("document").ready(function () {
                return $banners.removeClass("dismissed");
            });
            (0, _jquery2.default)(".dismiss-banner").on("click", function (e) {
                var $banner = void 0;
                var callback = void 0;
                e.preventDefault();
                $banner = (0, _jquery2.default)(this).parents(".banner");
                callback = $banner.data("callback");
                $banner.slideUp();
                if (typeof callback === "string") {
                    return _jquery2.default.get("//" + url_to_array[2] + "/" + callback, function (data) {});
                }
            });
        }
    }

    return Banner;
}();

exports.default = Banner();